import api from '@/services/api/config';

const path = 'v1/wareneingangspruefung/eingabeart';

export default {
  getById: (id) => api.get(`${path}/${id}`),
  get: () => api.get(path),
};
